var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleFever(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -2045.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Fever",
    transform: "translate(2352.000000, 2044.999823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9831475,4.99950261e-05 L15.161,0.00417726552 C16.784,0.0891772655 18,1.54517727 18,3.17017727 L18,3.17017727 L18,19.7711773 C18,20.3761773 18.277,20.9441773 18.75,21.3221773 C20.121,22.4211773 21,24.1061773 21,26.0001773 C21,29.5531773 17.912,32.3841773 14.274,31.9571773 C11.653,31.6491773 9.48,29.5691773 9.075,26.9621773 C8.722,24.6941773 9.643,22.6221773 11.229,21.3391773 C11.708,20.9531773 12,20.3841773 12,19.7701773 L12,19.7701773 L12,3.00017727 C12,1.29017727 13.431,-0.0858227345 15.161,0.00417726552 Z M16,7.00017727 L14,7.00017727 L14,23.1841773 C12.837,23.5971773 12,24.6951773 12,26.0001773 C12,27.6571773 13.343,29.0001773 15,29.0001773 C16.657,29.0001773 18,27.6571773 18,26.0001773 C18,24.6951773 17.163,23.5971773 16,23.1841773 L16,23.1841773 L16,7.00017727 Z M24.001,15.0001773 L24.001,17.0001773 L20,17.0001773 L20,15.0001773 L24.001,15.0001773 Z M24.001,11.0001773 L24.001,13.0001773 L20,13.0001773 L20,11.0001773 L24.001,11.0001773 Z M24.001,7.00017727 L24.001,9.00017727 L20,9.00017727 L20,7.00017727 L24.001,7.00017727 Z M24.001,3.00017727 L24.001,5.00017727 L20,5.00017727 L20,3.00017727 L24.001,3.00017727 Z",
    id: 284
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleFever);
export default __webpack_public_path__ + "static/media/life-and-people-fever.99c36013.svg";
export { ForwardRef as ReactComponent };